export const hideHamburgerPlugin = {
  afterRender({ updateHeaderProps }) {
    updateHeaderProps({ hamburgerState: 'hidden' });
  },
};
